// Vue
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import { Observer } from "mobx-vue";
import { AbhHandlersuche } from "../../../common/interfaces/unimog/AbhHandlersuche";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class Abhbox extends Vue {
  @Prop()
  public abh!: AbhHandlersuche;

  @Prop()
  public translation!: { [key: string]: string };

  private isOpen: boolean = false;

  private get mailToLink() {
    return "mailto: " + this.abh.mail;
  }
}
